var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-collapse", attrs: { shadow: "hover" } },
        [
          _c("app-header-dados-processo", {
            attrs: {
              processo: _vm.processo,
              isCCR: false,
              dadosCadastros: _vm.dadosCadastros
            }
          })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            [
              _c(
                "el-steps",
                {
                  staticClass: "card-container",
                  attrs: {
                    active: _vm.active,
                    "finish-status": "success",
                    simple: "simple"
                  }
                },
                [_c("el-step", { attrs: { title: "Confirmar dados da VTN" } })],
                1
              ),
              _vm.active === 0
                ? _c("validation-observer", {
                    ref: "validation",
                    attrs: { tag: "div" }
                  })
                : _vm._e(),
              _vm.active === 0
                ? _c(
                    "div",
                    [
                      _vm.dadosVtn
                        ? _c("visualizarVtnRR", {
                            attrs: {
                              vtn: _vm.dadosVtn,
                              processo: _vm.processo,
                              isUsuarioExterno: false,
                              isVisualizar: _vm.visualizar
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c("app-buttons-cadastro", {
                attrs: {
                  isPrimeiroPasso: true,
                  showButtonCancelar: true,
                  isUltimoPasso: true
                },
                on: { cancelar: _vm.cancelar, finalizar: _vm.finalizar }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-923336cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-923336cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/ConferirVTN.vue
// module id = null
// module chunks = 